<div style="display:inline-block">
    <div [nTooltip]="taskDropdown"
        [nTooltipOverlayClass]="isSmallSize ? ['header-tip', 'small-size'] : ['header-tip']"
        [nTooltipPlacement]="isSmallSize ? 'leftTop' : 'bottom'"
        nTooltipTrigger="click"
        nTooltipTheme="black"
        [(nTooltipVisible)]="tooltipVisible">
        <svg class="icon header-icon">
            <use xlink:href="#app-icon-icon-create-circle"></use>
        </svg>
    </div>
</div>
<ng-template #taskDropdown>
    <div class="header-tip-box">
        <ul>
            <li
                *ngIf="resourceItems && resourceItems.length"
                class='header-tip-title'>
                <h3>{{i18nStr.service_title}}</h3>
            </li>
            <li *ngFor="let item of resourceItems"
                [class.header-tip-item-disabled]="item.disabled"
                (click)="item.command(item)">{{item.label}}</li>
            <div
                *ngIf="resourceItems && resourceItems.length"
                class='header-tip-space'>
            </div>
            <li
                *ngIf="protectionItems && protectionItems.length"
                class='header-tip-title'>
                <h3>{{i18nStr.dataProtection}}</h3>
            </li>
            <li *ngFor="let item of protectionItems"
                [class.header-tip-item-disabled]="item.disabled"
                (click)="item.command(item)">{{item.label}}</li>
        </ul>
    </div>
</ng-template>
